module.exports = __webpack_public_path__ + "static/img/Joash-Papalii.895490a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joash-Papalii.jpg
// module id = RuJw
// module chunks = 0